import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import { Notification } from 'base-ui'

export const ProductPricingEprescriptionExplanation: FC = () => {
  const i18n = useIntl()

  return (
    <Notification
      className="my-4 bg-light-primary-low"
      icon={<IconInfo />}
      severity="info"
      title={i18n.formatMessage({
        id: 'productPricing.modal.productSection.ePrescription.title',
      })}
    >
      <p>
        <FormattedMessage id="productPricing.modal.productSection.ePrescription.paragraphOne" />
      </p>
      <p className="mt-4">
        <FormattedMessage id="productPricing.modal.productSection.ePrescription.paragraphTwo" />
      </p>
    </Notification>
  )
}
